








































import Vue from "vue";
import iwButtonLoading from "@/shared/components/ButtonLoading.vue";
import iwExtendedDate from "@/myImmoweb/modal/ExtendedDate.vue";
import iwBackOfficeActionReason from "@/myImmoweb/modal/BackOfficeActionReason.vue";

import { BackOfficeAction } from "@/shared/interfaces/BackOfficeAction.interface";
import { extendClassified } from "@/shared/scripts/BackOfficeApi";

import { mapState, mapActions } from "vuex";
import { datetime } from "datetime-attribute";
import { MILLISECONDS_PER_DAY } from "@/shared/scripts/helpers/date";
import { i18n } from "@/shared/scripts/helpers/translation/i18n";

export default Vue.extend({
    components: {
        iwButtonLoading: iwButtonLoading,
        iwExtendedDate: iwExtendedDate,
        iwBackOfficeActionReason: iwBackOfficeActionReason
    },

    data: function() {
        return {
            isLoading: false,
            errors: [] as string[],
            reason: {} as BackOfficeAction
        };
    },

    computed: {
        ...mapState("MyClassifiedsModule", ["classifiedToExtend"]),

        /**
         * The new expiration date must be:
         * - after the existing one;
         * - after today.
         */
        minDate: function(): string {
            const today = new Date();
            const expirationDate = new Date(this.classifiedToExtend.expirationDate);

            const lowerDate = expirationDate.getTime() - today.getTime() > 0
                ? expirationDate
                : today;

            // [expiration date + 1 day] or tomorrow
            const minDate = new Date(lowerDate.getTime() + MILLISECONDS_PER_DAY);

            return datetime(minDate);
        },
    },

    created: function() {
        this.updateDate(this.minDate);
    },

    methods: {
        ...mapActions({
            closeMasqueradeModal: "ModalModule/closeMasqueradeModal",
        }),

        updateInfo: function(info: string) {
            this.reason.info = info;
        },

        updateDate: function(expirationDate: string) {
            this.reason.expirationDate = expirationDate;
        },

        extendClassifiedCall: function() {
            this.isLoading = true;
            extendClassified(this.reason).then(res => {
                this.isLoading = false;
                if (res as boolean) {
                    this.$emit("success");
                    this.closeMasqueradeModal();
                }
            }).catch((errors: string[]) => {
                this.dialog.alert(i18n.t("server_not_responding_error").toString());
                this.errors = errors;
                this.isLoading = false;
            });
        }
    }
});
